'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _combineStyles = require('../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _darken = require('../internal/darken');

var _darken2 = _interopRequireDefault(_darken);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = function root() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors2.default.theme;
  var inverted = arguments[1];
  var iconButton = arguments[2];
  var disabled = arguments[3];
  var flatButton = arguments[4];
  var overrideStyle = arguments[5];

  var style = (0, _combineStyles2.default)(_styles2.default.button, {
    backgroundColor: color,
    ':hover': { backgroundColor: (0, _darken2.default)(color, 0.15) }
  });
  var invertedStyle = (0, _combineStyles2.default)(_styles2.default.inverted, { color: color });

  if (iconButton) {
    style = _styles2.default.iconButton;
  }

  if (disabled) {
    style = (0, _combineStyles2.default)(style, _styles2.default.disabled);
  }

  if (flatButton) {
    style = (0, _combineStyles2.default)(style, _styles2.default.flatButton);
  }

  if (inverted) {
    return (0, _combineStyles2.default)((0, _combineStyles2.default)(style, invertedStyle), overrideStyle);
  }

  return (0, _combineStyles2.default)(style, overrideStyle);
};

exports.default = {
  root: root
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/button/get-styles.js
// module id = 798
// module chunks = 0